<script>
export default {
  methods:  {
    async downloadPhoto(photo) {
      const request = await photo.getImage();

      if(photo.high_resolution) {
        this.downloadBlobImage(request.response.data);
      } else {
        this.getBase64Image(request.response.config.url);
      }
    },
    downloadBlobImage(data) {
      const link = document.createElement('a');

      link.href = window.URL.createObjectURL(new Blob([data]));;
      link.setAttribute('download', this.currentPhoto.filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    getBase64Image(url) {
      const _this = this,
        img = new Image();
      let imageTexts = [];

      if(this.competitor !== null && this.competitor.image_texts.length > 0) {
        imageTexts = this.competitor.image_texts;
      }

      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        imageTexts.forEach(imageText => {
          _this.renderText(imageText, canvas);
        });

        const dataURL = canvas.toDataURL("image/jpeg");
        _this.downloadImage(dataURL);
      }
      img.src = url
    },
    downloadImage(dataURL) {
      const url = dataURL,
          link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', this.currentPhoto.filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    renderText(imageText, canvas) {
      var text = canvas.getContext("2d"),
        fontStyle = imageText.font_style;

        text.font = `${fontStyle} ${imageText.font_size}px ${imageText.font_family}`;
        text.fillStyle = imageText.font_color;

        text.fillText(
          imageText.text,
          (imageText.x_position * 2) + imageText.font_size,
          (imageText.y_position * 2) + imageText.font_size
        );
    },
    openSignin() {
      this.$alertify.error(this.$t("auth.downloadRequiredLogin"));
      this.$root.$emit("openSignIn");
    }
  },
  computed: {
    requireSignIn() {
      return this.event.download_session && !this.currentUser;
    }
  }
}
</script>
